import { cn } from "@quint/ui";
import { type UseThemeProps } from "next-themes/dist/types";
import { type SVGProps } from "react";

export const CircleGradient = ({
  theme,
  ...props
}: SVGProps<SVGSVGElement> & { theme: UseThemeProps["theme"] }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="128"
    fill="none"
    {...props}
  >
    <rect
      width="127"
      height="127"
      x=".5"
      y=".5"
      stroke={theme === "dark" ? "url(#dark)" : "url(#light)"}
      rx="63.5"
      className={cn(theme === "dark" && "mix-blend-lighten")}
    />
  </svg>
);
